<template>
    <div class="nav-pos">

        <!--Barra de navegacion inferior -->
       <v-toolbar class="barra_nav">
      
                <div class="navegacion">
                  <a href="#"><img src="@/assets/imagenes_compartidas/Menu_Interfaz_basica/Abecedario.svg"  alt=""></a>
                  <a href="#"><img src="@/assets/imagenes_compartidas/Menu_Interfaz_basica/Glosario.svg"  alt=""></a>
                  <a href="#"
                   @click="closeModalBurguer()"
                   class="hamburguesa"><img src="@/assets/imagenes_compartidas/Menu_Interfaz_basica/Menu_unidad.svg"  alt=""></a>
                  <a href="#"><img src="@/assets/imagenes_compartidas/Menu_Interfaz_basica/Ajustes.svg"  alt=""></a>
                  <a href="#"><img src="@/assets/imagenes_compartidas/Menu_Interfaz_basica/Creditos.svg"  alt=""></a>
              </div>
       
       </v-toolbar>
     
    </div>
</template>
<script>

    import scormmixins from '../js/mixins/scormmixins'
    import Glosario from '@/components/Glosario'
    import resize from 'vue-resize-directive'

 export default {
  data() {
    return {
      MeniTitle: "Unidade 1",
      
    };
  },
  methods: {
    closeModalBurguer() {
      console.log("Click en la hamburguer!!!")
      // this.$store.commit("menuBurguer");
      // console.log("mutations: " + this.$store.state.MenuHamburguesa)
      // return this.$store.state. MenuHamburguesa;
    },
  },
  computed: {
   
  }
};
</script>


<style lang="scss" scoped>
    @import '../sass/globals';

.nav-pos{
  position:fixed;
  bottom: 0;
  width: 100%;
  height: 59px;
}
.barra_nav{
width: 100%;
background-image: url("../assets/imagenes_compartidas/Fondo_Menu_inferior_optimo.svg");
background-size: cover;
}

.navegacion {
  display: flex;
  width: 100%;
  height: 100%;
justify-content: center;
align-items: center;
align-content: center;
background-image: url("../assets/imagenes_compartidas/Fondo_Menu_inferior_optimo.svg");
background-size: cover;

a{
z-index: 15;
cursor: pointer;
}



a{
  cursor: pointer;
  margin: 3%;
}


}


        .container-nav-main{
            
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: flex-end;
            align-content: flex-end;
            align-items: flex-end;
            


        .nav-container {
            width: 100%;
          
            background: purple;
            position: absolute;
            display: grid;
            grid-template-columns: repeat(1,100%);

        .navegacion_main{
              background-image: url("../assets/imagenes_compartidas/Fondo_Menu_inferior_optimo.svg");
              background-size: cover;
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-content: center;
              text-align: center;

    //  /*Lita del menu ul*/ 
    //     .lista-vue{
    //         width: 100%;
    //         display: inline-flex;
    //         justify-content: space-between;
    //         list-style: none;
    //         align-content: center;
    //         text-align: center;
    //         align-items: center; 
    //         cursor: pointer;
    //         margin-left: 10px;
    //         margin-right: 10px;
    //         padding: 5px;
           
   
    //  /*Hamburguesa main*/ 
    //     .icon-centro{ 
    //         background-image: url("../assets/imagenes_compartidas/Menu_Interfaz_basica/Menu_unidad.svg");
    //         background-size: cover;
    //         display: flex;
    //         align-items: center;    
    //         justify-content: center;
    //         align-content: center; 
    //         width: 70px;
    //         height: 70px;
    //       }
    //       .icon-glosario{
    //            background-image: url("../assets/imagenes_compartidas/Menu_Interfaz_basica/Glosario.svg");
    //           background-size: contain;
    //         display: flex;
    //         width: 60px;
    //         height: 60px;
           
    //       }
    //        .icon-abecedario{
    //            background-image: url("../assets/imagenes_compartidas/Menu_Interfaz_basica/Abecedario.svg");
    //         background-size: contain;
    //         display: flex;
    //         width: 60px;
    //         height: 60px;
    //       }
    //        .icon-creditos{
    //            background-image: url("../assets/imagenes_compartidas/Menu_Interfaz_basica/Creditos.svg");
    //         background-size: contain;
    //         display: flex;
    //        width: 60px;
    //         height: 60px;
    //       }
    //        .icon-ajustes{
    //            background-image: url("../assets/imagenes_compartidas/Menu_Interfaz_basica/Ajustes.svg");
    //         background-size: contain;
    //         display: flex;
    //         width: 60px;
    //         height: 60px;
    //       }
    //             .icon{
    //               color: white;
    //               margin: 20px;
    //             }
    //         }
        }
    }

}   
        //   Elimina la margen para celulares y cambia el tamaño para no hacer overlap con la barra
     

</style>
